import { useMemo } from "react"
import { Chat } from "@/reducers/chatsSlice"
import { WorkTimePanel } from "@/components/tacho/WorkTimeCard"
import { useChatTachos } from "@/hooks/useChatTachos"
import { useMinuteClock } from "@/hooks/useMinuteClock"
import { chatWorkTime } from "@/lib/workTime"

const WorkTimeWidgetBody = ({ chat }: { chat: Chat }) => {
  const { tachos, isDoubleCrew } = useChatTachos(chat.jid)
  const now = useMinuteClock()
  const workTimes = useMemo(
    () =>
      chatWorkTime(
        tachos.map(({ tacho }) => tacho),
        isDoubleCrew,
        now,
      ),
    [tachos, isDoubleCrew, now],
  )
  return (
    <div data-testid="work-time-tab" className="h-full">
      <WorkTimePanel workTimes={workTimes} />
    </div>
  )
}

export default WorkTimeWidgetBody
